import { render, staticRenderFns } from "./searchIndex.vue?vue&type=template&id=5c981d4a&"
import script from "./searchIndex.vue?vue&type=script&lang=js&"
export * from "./searchIndex.vue?vue&type=script&lang=js&"
import style0 from "./searchIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports